// Export UI translations for apps to register
import enRecords from './locales/en/records-translations.json';
import enChat from './locales/en/chat-translations.json';
import enCommon from './locales/en/common-translations.json';
import enTasks from './locales/en/tasks-translations.json';
import enProgress from './locales/en/progress-translations.json';
import esRecords from './locales/es/records-translations.json';
import esChat from './locales/es/chat-translations.json';
import esCommon from './locales/es/common-translations.json';
import esTasks from './locales/es/tasks-translations.json';
import esProgress from './locales/es/progress-translations.json';

export const uiTranslations = {
  en: {
    records: enRecords,
    chat: enChat,
    common: enCommon,
    tasks: enTasks,
    progress: enProgress,
  },
  es: {
    records: esRecords,
    chat: esChat,
    common: esCommon,
    tasks: esTasks,
    progress: esProgress,
  },
};
